import React from "react";
import Mockman from "mockman-js";
export default function MockmanComponent() {
  return (
    <div>
      <Mockman />
    </div>
  );
}
